<template>
  <div>
    <div v-if="error" class="scenery">
      <router-link :to="{ name: 'chrs' }">
        <img src="/img/Logo.png" />
      </router-link>
      <div class="stars">
        <div v-for="i in 60" :key="i" class="star"></div>
      </div>
      <div class="message">
        <h2>{{ error }}</h2>
      </div>
      <div class="action">
        <Button @click="goBack" label="Take me back" />
      </div>
    </div>
    <!-- Splash Screen -->
    <div v-else class="splash-screen">
      <div class="splash-loader-container">
        <svg
          class="splash-loader"
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            class="splash-path"
            fill="none"
            stroke-width="6"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"
          ></circle>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { post } from '@/api/Services'
import AuthService from '@/services/auth.service'
import router from '@/router'
import { setItem } from '@/store/localStorage'

export default {
  name: 'LinkedInCallback',
  data() {
    return {
      loading: true,
      error: null,
      clientId: process.env.VUE_APP_LINKEDIN_CLIENT_ID,
      clientSecret: process.env.VUE_APP_LINKEDIN_CLIENT_SECRET,
      redirectUri: process.env.VUE_APP_LINKEDIN_REDIRECT_URI,
      menuparam: null,
      menuLoader: true,
    }
  },
  async created() {
    try {
      await this.handleCallback()
    } catch (err) {
      this.error = 'LinkedIn ile giriş yapılırken bir hata oluştu.'
      console.error('LinkedIn callback error:', err)
    } finally {
      this.loading = false
    }
  },
  methods: {
    async getUserMenu() {
      const params = {
        sqlId: 27,
        parameters: JSON.stringify([]),
      }

      try {
        const data = await post('Commons/Executer', params)
        if (data) {
          this.menuparam = data
          setItem('userMenu', data)
          this.menuSet()
        }
      } finally {
        this.menuLoader = false
        setItem('menuLoader', this.menuLoader)
      }
    },
    menuSet() {
      let menu = []

      this.menuparam.forEach((each) => {
        let menuObj = {
          id: each.id,
          label: each.name,
          title: each.description,
          src: `${each.icon_name}.svg`,
          activeSrc: `${each.icon_name}.active.svg`,
          to: each.name === 'Definitions' ? '' : each.link,
          auth_code: each.link || '/',
          select: each.select,
          delete: each.delete,
          insert: each.insert,
          update: each.update,
          items: [],
        }

        if (each.parent_id != null) {
          const parentMenu = menu.find((m) => m.id == each.parent_id)
          const itemsObject = {
            label: each.name,
            title: each.description,
            src: `${each.icon_name}.svg`,
            activeSrc: `${each.icon_name}.active.svg`,
            to: each.link,
            auth_code: each.link,
            select: each.select,
            delete: each.delete,
            insert: each.insert,
            update: each.update,
          }

          if (parentMenu) {
            parentMenu.items.push(itemsObject)
          } else {
            menuObj.items.push(itemsObject)
          }
        } else {
          menu.push(menuObj)
        }
      })

      setItem('menu', menu)
    },
    async handleCallback() {
      try {
        // Check for error parameter first
        const error = this.$route.query.error
        if (error === 'user_cancelled_login') {
          this.$router.push('/login')
          return
        }

        const code = this.$route.query.code
        if (!code) {
          throw new Error('Authorization code not found')
        }

        const response = await AuthService.linkedinAccount(code)
        if (response) {
          const redirectPath =
            window.sessionStorage.getItem('linkedin_redirect') ||
            '/chrs/job-openings'
          this.$router.push(redirectPath)
        }
      } catch (error) {
        this.error =
          error.message || 'An error occurred during LinkedIn authentication'
        // Remove splash screen when error occurs
        const splash = document.querySelector('.splash-screen')
        if (splash && this.error) {
          splash.style.display = 'none'
        }
      }
    },
    goBack() {
      const referrer = document.referrer
      const currentHost = window.location.host
      if (!referrer || referrer === '' || !referrer.includes(currentHost)) {
        this.$router.push('/login')
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$shadow: #fc6c2a;
$light: #fedbae;
$gradient1: #003e75;
$gradient2: #4d94d2;

@mixin background-image($gradient) {
  background: $gradient;
  background: -webkit-linear-gradient($gradient);
  background: -moz-linear-gradient($gradient);
  background: -o-linear-gradient($gradient);
  background: -ms-linear-gradient($gradient);
}

@mixin box-shadow($shadow) {
  -webkit-box-shadow: $shadow;
  -moz-box-shadow: $shadow;
  -ms-box-shadow: $shadow;
  box-shadow: $shadow;
}

@mixin transition($properties) {
  -webkit-transition: $properties;
  -moz-transition: $properties;
  -o-transition: $properties;
  transition: $properties;
}

@keyframes shining {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}

.scenery {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 5px;
  color: #fff;
  @include background-image(linear-gradient($gradient1, $gradient2));
  @include box-shadow(rgba(0, 0, 0, 0.8) 0px 0px 100px);
}

.star {
  position: absolute;
  z-index: 1;
  background-color: #fff;
  animation-name: shining;
  animation-timing-function: ease;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  @include box-shadow(#fff 0px 0px 5px);
  border-radius: 200px;
}

@for $i from 1 through 60 {
  $size: random(3) + 0px;
  .star:nth-child(#{$i}) {
    width: $size;
    height: $size;
    bottom: random(618) + 0px;
    left: random(1000) + 0px;
    animation-duration: random(4) / random(3) + 0s;
  }
}

.message {
  position: relative;
  z-index: 50;
  text-align: center;
  margin: 2rem 0;
  h2 {
    font-size: 1.8rem;
    color: #fff;
  }
}

.action {
  margin-top: 10px;
  button {
    padding: 8px 16px;
    font-size: 1.2rem;
    color: #fff;
    border: 2px solid $shadow;
    background-color: $shadow;
    border-radius: 50px;
    @include transition(all 0.2s ease);
    box-shadow: 0px 0px 15px $shadow;
    &:hover {
      cursor: pointer;
      background-color: transparent;
    }
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>
